import { IAttrValue } from "@multiweb/types/contracts";
import { DateUtils } from "../../../../Global/Base/Utils/DateUtils";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { TimeEdit } from "../../../UI.BaseControls/TimeEdit";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DefaultEditTemplate } from "../Templates/DataTypeEditTemplates/DefaultEditTemplate";
import { ItemTemplate } from "../Templates/ItemTemplate";
import { DateTimeColumn } from "./DateTimeColumn";

export class TimeColumn extends DateTimeColumn {
    //#region Fields
    //#endregion

    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (!(val instanceof Date))
            return "";

        if (!this.displayFormat || this.displayFormat.length == 0)
            this.displayFormat = "t";

        if (!DateTimeColumn._formatFncs.has(this.displayFormat))
            DateTimeColumn._formatFncs.set(this.displayFormat, DateUtils.getDateToStringFunction(this.displayFormat));

        const fncs = DateTimeColumn._formatFncs.get(this.displayFormat);

        // Přidáno z důvodu, že pokud se jednalo o time, tak ve většině případů měl nastavený nízky rok a dochazelo k zápornému timestamp a tím
        // ve většině prohlížečů docházelo k špatnému formatování času, resp. přičítání minut

        try {
            if (val.getFullYear() < 0)
                val.setFullYear(0);
        } catch (e) {
            // Prázdný catch
        }

        return fncs.format(val);
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ItemTemplate();
        this.editItemTemplate = new DefaultEditTemplate(TimeEdit);
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-timecolumn", TimeColumn);
